import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '../services';

/**
 * Protege la ruta `/services`. "Servicios" no está en el catálogo AuthZ, así
 * que no se gobierna por `*hasPermission` sino por identidad: solo el súper
 * admin DIY o el rol web administrador. El criterio lo resuelve backend-auth y
 * llega en el perfil como `can_access_services`; aquí solo se respeta ese flag
 * (misma verdad que usa el menú lateral). Ocultar el menú no basta: sin este
 * guard cualquier usuario logueado entraría por URL directa.
 */
@Injectable({ providedIn: 'root' })
export class ServicesGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const user = this.accountService.userValue;

        if (!this.accountService.isLoggedIn() || !user) {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        if (user.can_access_services) {
            return true;
        }

        this.router.navigate(['/']);
        return false;
    }
}
